import config from '../../utils/config';

export const getPathPrefix = (
  fileName: string,
  company: string,
  project: string = config.default_project,
): string => {
  return `/${company}/${project}/tessellation/files/${fileName}`;
};
